import crud from './helpers/crud';

// Loads the org's Athena routing config plus the pick-lists the settings UI
// needs (document categories, current label allowlist).
const credentialQuery = (credentialId) => (
  credentialId ? `?emr_integration_credential_id=${encodeURIComponent(credentialId)}` : ''
);

const getAthenaRouting = (credentialId) => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_ATHENA_ROUTING',
      fail: 'FAILED_GET_ATHENA_ROUTING',
      end: 'FINISH_GET_ATHENA_ROUTING',
    },
    method: 'GET',
    url: `/api/v1/athena_routing${credentialQuery(credentialId)}`,
  })
);

// Replaces the routing rules and/or label allowlist wholesale.
const updateAthenaRouting = (payload, credentialId) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_ATHENA_ROUTING',
      fail: 'FAILED_UPDATE_ATHENA_ROUTING',
      end: 'FINISH_UPDATE_ATHENA_ROUTING',
    },
    method: 'PUT',
    url: `/api/v1/athena_routing${credentialQuery(credentialId)}`,
    data: payload,
  })
);

export { getAthenaRouting, updateAthenaRouting };
